import React, { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

interface PasswordInputProps {
  placeholder?: string;
  value: string;
  onChange: (value: string) => void;
  type?: "text" | "password";
  showToggle?: boolean;
  style?: React.CSSProperties;
  className?: string;
}

const PasswordInput: React.FC<PasswordInputProps> = ({
  placeholder,
  value,
  style,
  onChange,
  type,
  showToggle = true,
  className,
}) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div style={{ position: "relative", display: "inline-block", width: "100%" }}>
      <input
  className={`no-default-eye ${className ?? ""}`}
  type={type ? type : showPassword ? "text" : "password"}
  placeholder={placeholder || "Enter password"}
  value={value}
  onChange={(e) => onChange(e.target.value)}
  style={{
    ...style,
    boxShadow: "none",
    outline: "none",
    border: style?.border || "1px solid #cccccc",
  }}
/>

      {showToggle && (
        <span
          onClick={() => setShowPassword(!showPassword)}
          style={{
            position: "absolute",
            right: "8px",
            top: "50%",
            transform: "translateY(-50%)",
            cursor: "pointer",
            backgroundColor: "transparent",
            display: "block",
            color: value ? "#333333" : "#bbbbbb",
          }}
        >
          {showPassword ? <Eye size={18} /> : <EyeOff size={18} />}
        </span>
      )}
    </div>
  );
};

export default PasswordInput;
